import { render } from "./LaboratoryTable.vue?vue&type=template&id=3f06cfb1"
import script from "./LaboratoryTable.vue?vue&type=script&lang=js"
export * from "./LaboratoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__